// Components
import {
    SocialInboxChatView,
    SocialInboxMenuDesktop,
    SocialInboxMessageList
} from '@/components/pages/conversations/SocialInbox';

export const SocialInboxDesktop = () => {
    return (
        <div data-testid="social-inbox-desktop" className="hidden size-full gap-px lg:flex">
            <SocialInboxMenuDesktop className="flex-1 px-5 py-8" />
            <SocialInboxMessageList className="flex-[2] p-8 pr-4" />
            <SocialInboxChatView className="max-w-[50%] flex-[3]" />
        </div>
    );
};
